import { render } from "./index.vue?vue&type=template&id=e6c22f76&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=e6c22f76&lang=scss&scoped=true"

import exportComponent from "D:\\project\\php\\quick_wucode\\quick_wucode\\quickadmin\\vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6c22f76"]])

export default __exports__